export default "### 支持正版AstraEditor\n> https://github.com/astraeditor/\n\n> https://editors.astras.top/。\n";